import { render, staticRenderFns } from "./EditInsuranceForm.vue?vue&type=template&id=a72a53f8&scoped=true"
import script from "./EditInsuranceForm.vue?vue&type=script&lang=js"
export * from "./EditInsuranceForm.vue?vue&type=script&lang=js"
import style0 from "./EditInsuranceForm.vue?vue&type=style&index=0&id=a72a53f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72a53f8",
  null
  
)

export default component.exports